import {AbstractLitInputComponent} from "../../abstract-lit-input.component";
import {html, PropertyValues} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {createRef, ref, Ref} from "lit/directives/ref.js";
import {UuidHelper} from "../../../helpers/uuid.helper";
import {live} from "lit/directives/live.js";
import {DateHelper} from "../../../helpers/date.helper";

/**
 * input value must be in minutes
 */
@customElement('ha-input-duration')
export class HaInputDurationComponent extends AbstractLitInputComponent<number> {

    private _ref: Ref<HTMLInputElement> = createRef<HTMLInputElement>();

    private _id = UuidHelper.generateV7();

    protected shouldUpdate(_changedProperties: PropertyValues): boolean {
        return super.shouldUpdate(_changedProperties) || DateHelper.convertDurationToString(this.value ?? 0) !== this._ref.value?.value;
    }

    protected render(): unknown {
        return html`
            <div class="wrapper">
                <input type="text"
                       id="${this._id}"
                       data-type="duration"
                       ${ref(this._ref)}
                       title=${this.value?.toString()}
                       @blur=${this._onBlur}
                       .value=${live(DateHelper.convertDurationToString(this.value ?? 0))}
                />
            </div>
            ${this._renderHelperText()}
        `;
    }

    private _onBlur(evt: InputEvent): void {
        const durationString = (evt.target as HTMLInputElement).value;
        const oldValue = this.value;
        this.value = DateHelper.parseDurationString(durationString);
        const newDurationString = DateHelper.convertDurationToString(this.value);
        if (newDurationString !== durationString) {
            this.requestUpdate();
        }

        if (oldValue !== this.value) {
            this.fire(this.value);
        }
    }
}